export default "__VITE_ASSET__CXlrEmNg__"